/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getBrandCollection} from '../api'

 export const useQueryGetBrandCollection = createReactQueryHook('getBrandCollection', getBrandCollection)
